/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { DateTime } from 'luxon'
import { useIntl } from 'react-intl'
import { AreaChart, AreaChartProps } from '@mantine/charts'

type Datum = {
  count: number
  month: number
  year: number
}

type LabelledDatum = Datum & {
  label: string
}

export type ChartProps = Omit<AreaChartProps, 'data' | 'dataKey' | 'series'> & {
  data: Datum[]
}

function getXLabel (d: Datum): string {
  const dt = DateTime.fromObject({
    year: d.year,
    month: d.month
  })
  return dt.toLocaleString({ month: 'short', year: '2-digit' })
}

function EstatesPerMonthChart (props: ChartProps) {
  const { data, ...others } = props
  const intl = useIntl()

  const formattedData: LabelledDatum[] = useMemo(() => (
    data.map((el) => ({
      ...el,
      label: getXLabel(el)
    }))
  ), [data])

  return (
    <AreaChart
      data={formattedData}
      series={[
        {
          name: 'count',
          color: 'primary.2',
          label: intl.formatMessage({
            id: 'created',
            defaultMessage: 'Créé'
          })
        }
      ]}
      dataKey="label"
      tickLine="x"
      valueFormatter={(value) => intl.formatNumber(value)}
      {...others}
    />
  )
}

export default EstatesPerMonthChart
